/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Spinner from "../../components/Loader/Spinner";
import { useNavigate } from "react-router-dom";
import {
  BaseAPI,
  BaseURL,
  getQualificationsList,
  getSpecialitiesList,
} from "../../services/services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdGpsFixed } from "react-icons/md";
import { AiFillTag } from "react-icons/ai";
import {
  HiLocationMarker,
  HiSearch,
  HiArrowCircleRight,
  HiArrowCircleLeft,
  HiOutlineLocationMarker,
} from "react-icons/hi";
import { GoArrowUpRight, GoPrimitiveDot } from "react-icons/go";
import Autocomplete from "../../components/PlacesAutocomplete/Autocomplete";
import { ReactComponent as Calendar } from "../../assets/images/calendar3.svg";
import { ReactComponent as Money } from "../../assets/images/money.svg";
import { ReactComponent as Location } from "../../assets/images/location.svg";
import { ReactComponent as CirclePrimary } from "../../assets/images/circlePrimary.svg";
import { ReactComponent as CircleYellow } from "../../assets/images/circleYellow.svg";
import rightTick from "../../assets/icons/rightTick.png";
import SatisfyTreetment from "../../assets/icons/Satisfytreetment.png";
import SofaIcon from "../../assets/icons/Sofa.png";
import DoctorIcon from "../../assets/icons/Doctor.png";
import SheildIcon from "../../assets/icons/Shield.png";
import MoneyIcon from "../../assets/icons/Money.png";

import "../../components/HomepageSections/BounceDiv.css";

import "react-datepicker/dist/react-datepicker.css";
import { BsFillStarFill, BsStar } from "react-icons/bs";
import { FaUser } from "react-icons/fa";
import DoctorCarousel from "../../components/HomepageSections/DoctorsList";
import DoctorList from "../../components/HomepageSections/DoctorsList";
import Testimonials from "../../components/HomepageSections/Testimonials";

const NewHome2 = () => {
  const selectClass = "rounded-full shadow-lg text-sm py-2 px-3";

  let navigate = useNavigate();

  // document.title = "MyHCare Patients";
  document.title = "TeleSecure360 Patients";

  const user = localStorage.getItem("userData");
  const token = localStorage.getItem("token");
  // const address = JSON.parse(user).addresses[0];

  // const isGuest = localStorage.getItem("loggedInAsGuest");
  const isGuest = localStorage.getItem("loggedInAsGuest") === null ? null : localStorage.getItem("loggedInAsGuest") === "true";
  const defaultAddress = {
    latitude: 25.76905,
    longitude: -80.132234,
    address: "Miami Beach, Florida",
  };
  const parsedUser = user ? JSON.parse(user) : null;

  const address =
    // isGuest === "true"
    (isGuest === "true" || isGuest === null)
      ? defaultAddress
      : parsedUser?.addresses?.[0] || defaultAddress;

  const [isLoading, setisLoading] = useState(false);
  const [searchText, setsearchText] = useState("");
  const [doctorsList, setdoctorsList] = useState(null);
  const [cords, setcords] = useState({
    lat: address.latitude,
    lng: address.longitude,
  });
  const [searchLength, setsearchLength] = useState({
    byName: 0,
    byPlace: 0,
  });
  const [qualificationsList, setqualificationsList] = useState([]);
  const [specialitiesList, setspecialitiesList] = useState([]);
  //filters
  const [qual, setQual] = useState("");
  const [spec, setSpec] = useState("");
  const [doctorCount, setDoctorCount] = useState(0);
  const [filterSelected, setFilterSelected] = useState(false);

  //search text header
  const [text, setText] = useState("Recommended Doctors for You");

  const [recommends, setRecommends] = useState(null);

  const [showImage, setshowImage] = useState(false);
  const [doctors, setDoctors] = useState([]);

  //update doctor data getting doctor list  ( same as recommended)
  const updateDoctorList = (arr) => {
    // console.log(arr);
    let temp = [];
    arr.forEach((element) => {
      let obj = {};
      obj = {
        firstName: element.firstName,
        lastName: element.lastName,
        _id: element._id,
        specialities: element.specialityData ?? element?.specialities,
        addresses: element.addresses,
        profilePic: element.profilePic,
        consultationFee: element.consultationFee,
        consultationFeeAudioVideo: element.consultationFeeAudioVideo,
        consultationFeeInPerson: element.consultationFeeInPerson,
        avgRatings: element.avgRatings,
        bio: element?.bio,
        qualification: element?.qualification,
        expertize: element?.expertize,
      };

      temp.push(obj);
    });

    // console.log("new array", temp);
    if (temp.length > 0) setDoctors(temp);
    else setDoctors(null);
  };

  //getDate for esign
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  today = mm + "/" + dd + "/" + yyyy;

  const HandleSearch = (e) => {
    setsearchText((prev) => (prev = e.target.value));
    setsearchLength({
      ...searchLength,
      byName: e.target.value.length,
    });
  };

  //Get users current location
  async function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
    }
  }

  async function showPosition(position) {
    await setcords({
      ...cords,
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });

    reloadResult(); //for showing the instant results
  }

  const reloadResult = async () => {
    getDoctorList(cords.lat, cords.lng);
  };

  const getRecommendedData = () => {
    setisLoading(true);

    let myHeaders = new Headers({
      accept: "application/json",
      authorization: `${token}`,
    });

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    BaseAPI(`${BaseURL}/patient/getRecommendedData`, requestOptions)
      .then((result) => {
        // console.log(result);
        if (result.status !== 200) {
          toast.warn(result.message);
          if (result.status === 401) {
            localStorage.clear();
            navigate("/login");
          }
        }
        setRecommends(result?.data);
        setDoctors(result?.data?.recommendedDoctors);
        updateDoctorList(result?.data?.recommendedDoctors);
        setisLoading(false);
      })
      .catch((err) => toast.error("Something went wrong!"))
      .finally(() => setisLoading(false));
  };

  const getDoctorListForReset = (lat, lng, search) => {
    setisLoading(true);

    let myHeaders = new Headers({
      accept: "application/json",
      authorization: `${token}`,
    });

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    BaseAPI(
      `${BaseURL}/patient/getDoctorsList?${search?.length > 1 ? `searchUser=${search}&` : ""
      }longitude=${cords?.lng}&latitude=${cords?.lat}&radius=40&qualification=${qual
      }&speciality=${spec}&limit=100&isAdminVerified=true`,
      requestOptions,
    )
      .then((result) => {
        if (result.status !== 200) {
          toast.warn(result.message);
          if (result.status === 401) {
            localStorage.clear();
            navigate("/login");
          }
        }
        setdoctorsList(result.data);
        // setRecommends(prev => null)
        updateDoctorList(result?.data?.users);
        setText(`${result?.data?.usersCount} doctors found near you`);
      })
      .catch((err) => toast.error("Something went wrong!"))
      .finally(() => setisLoading(false));
  };

  const getDoctorList = (lat, lng) => {
    setisLoading(true);

    let myHeaders = new Headers({
      accept: "application/json",
      authorization: `${token}`,
    });

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    BaseAPI(
      `${BaseURL}/patient/getDoctorsList?${searchText.length > 1 ? `searchUser=${searchText}&` : ""
      }longitude=${cords.lng}&latitude=${cords.lat}&radius=40&qualification=${qual
      }&speciality=${spec}&limit=100&isAdminVerified=true`,
      requestOptions,
    )
      .then((result) => {
        if (result.status !== 200) {
          toast.warn(result.message);
          if (result.status === 401) {
            localStorage.clear();
            navigate("/login");
          }
        }
        setdoctorsList(result.data);
        // setRecommends(prev => null)
        updateDoctorList(result?.data?.users);
        setText(`${result?.data?.usersCount} doctors found near you`);
      })
      .catch((err) => toast.error("Something went wrong!"))
      .finally(() => setisLoading(false));
  };

  const filterClass = ` mt-5 `;

  useEffect(() => {
    getQualificationsList()
      .then((result) => setqualificationsList(result.qualification))
      .catch((err) => console.log(err));

    getSpecialitiesList()
      .then((result) => setspecialitiesList(result.speciality))
      .catch((err) => console.log(err));

    // getRecommendedData();
  }, []);

  useEffect(() => {
    if (searchText.length === 0 && spec?.length === 0 && qual?.length === 0) {
      getRecommendedData();
    }

    if (searchText.length === 0 && spec?.length > 0 && qual?.length > 0) {
      getDoctorListForReset();
    }
  }, [searchText, spec, qual]);

  const [selectedDoctorId, setSelectedDoctorId] = useState(null);

  const BookAppointment = (id, doctor) => {
    setSelectedDoctorId(id);
    navigate("/DoctorProfile", {
      state: { id: id, doctorProfile: doctor },
    });
  };

  // useEffect(() => {
  //   getDoctorList()
  // }, [qual , spec]);

  // useMemo(() => getDoctorList(), [qual , spec])

  //create new array for adding pagination
  const doctorCountArray = (arr) => {
    let paginatedArray = [];

    if (arr) {
      if (arr.slice(doctorCount, doctorCount + 10).length > 0)
        paginatedArray = arr.slice(doctorCount, doctorCount + 10);
      else setDoctorCount((prev) => prev * 0);
    }

    return paginatedArray;
  };

  useEffect(() => {
    // if (qual?.length > 0 || spec?.length > 0) {
    if (filterSelected) {
      setisLoading(true);

      let myHeaders = new Headers({
        accept: "application/json",
        authorization: `${token}`,
      });

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      // BaseAPI(
      //   `${BaseURL}/patient/getDoctorsList?${searchText.length > 1 ? `searchUser=${searchText}&` : ""
      //   }longitude=${cords.lng}&latitude=${cords.lat}&radius=40&qualification=${qual
      //   }&speciality=${spec}&limit=100&isAdminVerified=true`,
      //   requestOptions
      // )
      BaseAPI(
        `${BaseURL}/patient/getDoctorsList?longitude=${cords.lng}&latitude=${cords.lat}&radius=40&qualification=${qual
        }&speciality=${spec}&limit=100&isAdminVerified=true`,
        requestOptions,
      )
        .then((result) => {
          if (result.status !== 200) {
            toast.warn(result.message);
            if (result.status === 401) {
              localStorage.clear();
              navigate("/login");
            }
          }
          setdoctorsList(result.data);
          // setRecommends(prev => null)
          updateDoctorList(result?.data?.users);
          setText(`${result?.data?.usersCount} doctors found near you`);
        })
        .catch((err) => toast.error("Something went wrong!"))
        .finally(() => setisLoading(false));
    }
  }, [qual, spec]);

  const url =
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";

  const [activeTab, setActiveTab] = useState(1);

  const tabs = [
    { id: 1, label: "Consult a Doctor" },
    { id: 2, label: "Get prescriptions" },
    { id: 3, label: "My Appointments" },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);

    if (tabId === 1) {
      navigate("/doctors");
      return;
    }

    if (!token) {
      navigate("/login");
      return;
    }

    if (tabId === 2 || tabId === 3) {
      navigate("/appointment");
    }
  };

  const BounceDiv = ({ icon, text, gradient }) => {
    return (
      <div
        className={`bounce-div ${gradient ? "gradient-bg" : "bordered-bg"}`}
        onMouseEnter={(e) => e.currentTarget.classList.add("bounce")}
        onMouseLeave={(e) => e.currentTarget.classList.remove("bounce")}
      >
        <img className="w-12 h-12" src={icon} alt="waiting" />
        <span className="text">{text}</span>
      </div>
    );
  };

  const [activeIndex, setActiveIndex] = useState(0);

  // Example testimonials array

  const testimonials = [
    {
      name: "Ananya S",
      role: "Patient",
      image: "/avatar.jpg",
      text: "Booking an appointment took less than 2 minutes, and I spoke to a doctor the same day!",
      rotate: "-rotate-6",
    },
    {
      name: "Ananya S",
      role: "Patient",
      image: "/avatar.jpg",
      text: "Booking an appointment took less than 2 minutes, and I spoke to a doctor the same day!",
      rotate: "rotate-0",
    },
    {
      name: "Ananya S",
      role: "Patient",
      image: "/avatar.jpg",
      text: "Booking an appointment took less than 2 minutes, and I spoke to a doctor the same day!",
      rotate: "rotate-6",
    },
    {
      name: "Ananya S",
      role: "Patient",
      image: "/avatar.jpg",
      text: "Booking an appointment took less than 2 minutes, and I spoke to a doctor the same day!",
      rotate: "rotate-6",
    },
    {
      name: "Ananya S",
      role: "Patient",
      image: "/avatar.jpg",
      text: "Booking an appointment took less than 2 minutes, and I spoke to a doctor the same day!",
      rotate: "rotate-6",
    },
  ];
  const total = testimonials.length;

  const next = () => setActiveIndex((prev) => (prev + 1) % total);
  const prev = () => setActiveIndex((prev) => (prev - 1 + total) % total);

  return (
    // <div className="Home bg-Light-gray min-h-screen w-full">
    <div className="min-h-screen w-full pb-8">
      {/* <Navbar heading="Home" /> */}
      {/* <div className={`mx-8 py-6 mt-8`}>
        <div className="flex justify-between items-center w-auto wrap">
          <div className=" flex justify-between items-center w-auto gap-3 px-3 flex-grow">
            <div className="relative w-1/2">
              <input
                className="border rounded-lg p-2 w-full pl-8"
                placeholder="Search Doctor"
                onChange={(e) => HandleSearch(e)}
              />
              <HiSearch className="absolute left-1 bottom-2 text-lg opacity-50" />
            </div>
            <div className="relative  w-auto flex-grow">
              // <Autocomplete
              //   name={"filter"}
              //   personalInfo={cords}
              //   setpersonalInfo={setcords}
              //   Length={searchLength}
              //   setLength={setsearchLength}
              //   defaultValue={address.address}
              // />
              <input
                name="filter"
                className="border rounded-lg p-2 w-full pl-8"
                defaultValue={address.address}
                onChange={(e) => HandleSearch(e)}
              />
              <span
                onClick={async () => {
                  await getLocation();
                  setshowImage(true);
                }}
                className="text-secondary bg-white absolute right-2 top-2 text-lg cursor-pointer"
              >
                <MdGpsFixed />
              </span>
            </div>
            <button
              className="bg-primary  md:block mx-2 px-3 py-2 rounded-lg text-white"
              onClick={() => {
                setshowImage(true);
                getDoctorList(cords.lat, cords.lng);
              }}
            >

              <span className=" hidden md:inline-flex sm:hidden">Search Doctor</span>

              <HiSearch className="mx-3 text-lg inline-flex md:hidden" />

            </button>
          </div>
        </div>
      </div> */}

      <div
        className={`relative mx-9 py-20 mt-8 Background rounded-xl border border-primary`}
      >
        <div className="flex justify-center items-center w-full wrap">
          <div className="flex xl:w-3/4 md:w-4/4 w-full flex-col sm:flex-row items-center  mx-2 gap-4 px-2 py-3 rounded-xl bg-white border border-primary">
            <div className="relative  input-wrapper w-1/3">
              <input
                className="form-input text-base border-0 focus:border-0"
                placeholder=" "
                onChange={(e) => HandleSearch(e)}
                id="search"
                name="search"
              />

              <label
                htmlFor="search"
                className="form-input-label text-base top-1/2 -translate-y-1/2"
                style={{
                  zIndex: 1,
                  transition: "all 0.3s",
                }}
              >
                Search
              </label>

              <style>
                {`
    #search:focus + label,
    #search:not(:placeholder-shown) + label {
      transform: translateY(-120%) scale(1);
      color: #7c3aed;
    }
  `}
              </style>
            </div>
            <div className="border-l-2 border-Darkgray h-14 sm:block hidden md:block"></div>
            {/* <hr className="border-l-2 border-Darkgray w-full block sm:hidden md:hidden " /> */}

            <div className="relative ml-6 justify-center input-wrapper w-1/3">
              <input
                name="filter"
                id="filter"
                className="form-input text-base border-0 focus:border-0"
                defaultValue={address.address}
                onChange={(e) => HandleSearch(e)}
              />
              <label
                htmlFor="filter"
                className="form-input-label text-base top-1/2 -translate-y-1/2"
                style={{ zIndex: 1, transition: "all 0.3s" }}
              >
                Location
              </label>
              <style>
                {`
    #filter:focus + label,
    #filter:not(:placeholder-shown) + label {
       transform: translateY(-120%) scale(1);
      color: #7c3aed;
    }
  `}
              </style>
            </div>
            <button
              className="bg-primary md:block ml-auto mr-1 px-14 py-3 rounded-lg text-white"
              onClick={() => {
                navigate("/doctors", {
                  state: {
                    searchText,
                    location: address.address,
                    lat: cords.lat,
                    lng: cords.lng,
                    qualification: qual,
                    speciality: spec,
                  },
                });
              }}
            >
              Search
            </button>
          </div>
        </div>
        <div className="absolute -top-10 -right-11 ">
          <div className="relative">
            <CircleYellow className="w-32 h-32" />
          </div>
        </div>
        <div className="absolute -bottom-12 -left-10">
          <div className="relative">
            <CirclePrimary className="w-40 h-40" />
          </div>
        </div>
      </div>
      <div className={filterClass}>
        {/* recommended Specialiities */}
        {/* {  <div className="flex flex-col gap-4">
          <h1>Specialities</h1>
          <div>
            {recommends &&
              recommends?.recommendedSpecialities.map((item, i) => (
                <button
                  key={i}
                  className="p-2 flex flex-col bg-white rounded-lg shadow-lg items-center text-sm gap-3"
                  onClick={()=> {
                    console.log(item)
                    let temp;
                    temp = doctors.filter(doctor => {
                      return doctor.specialities.some((f) => {
                return  item._id === f._id;
  });
                    })
                    console.log( 'filtered array' , temp)
                    setDoctors(prev => temp)
                  }}
                >
                  <span className="flex justify-between items-center">
                    {" "}
                    <img
                      src={url}
                      className="h-14 rounded-full"
                      alt="logo"
                    />{" "}
                  </span>
                  <span>{item.specialityName}</span>
                </button>
              ))}
          </div>
        </div>} */}

        {/* stats  */}
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 pb-11 pt-20  px-6 lg:px-20 bg-gray-50 rounded-lg">
          {/* Left Section */}
          <div className="w-full lg:w-1/4 text-center lg:text-left">
            <h2 className="text-xl text-gray-800 leading-2">
              Your Trusted <br />
              <span className="text-primary healthcare-curve">
                Healthcare
              </span>{" "}
              <br />
              Providers
            </h2>

            <p className="mt-2 text-gray-500 text-sm lg:text-base">
              My focus has always been on providing compassionate,
              patient-centered, and personalized care to everyone I serve.
            </p>
          </div>

          {/* Right Section */}
          <div className="w-full flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Card 1 */}
            <div className="speciality-card bg-white rounded-xl p-5 shadow-md group transition-all duration-300 cursor-pointer">
              <div className="flex items-center justify-between ">
                <h3 className="text-lg  group-hover:text-white transition-colors duration-300">
                  100%
                </h3>

                <div
                  className="flex items-center justify-center rounded-full w-11 h-11 group-hover:bg-white bg-opacity-80 transition-colors duration-300"
                  style={{ backgroundColor: "#F6F5FB" }}
                >
                  <img
                    src={rightTick}
                    alt="doctors"
                    className="w-5 h-5 object-contain"
                  />
                </div>
              </div>

              <p className="mt-2 text-gray-500  group-hover:text-white transition-colors duration-300">
                Our Doctors Certified
              </p>
            </div>

            {/* Card 2 */}
            <div className="speciality-card bg-white rounded-xl p-5 shadow-md group transition-all duration-300 cursor-pointer">
              <div className="flex items-center justify-between">
                <h3 className="text-lg  group-hover:text-white transition-colors duration-300">
                  25M+
                </h3>

                <div
                  className="flex items-center justify-center rounded-full w-11 h-11  group-hover:bg-white/80 transition-colors duration-300"
                  style={{ backgroundColor: "#F6F5FB" }}
                >
                  <FaUser className="w-5 h-5 text-darkPrimary" />
                </div>
              </div>

              <p className="mt-1 text-gray-500 group-hover:text-white transition-colors duration-300">
                Happy global users
              </p>
            </div>

            {/* Card 3 */}
            <div className="speciality-card bg-white rounded-xl p-5 shadow-md group transition-all duration-300 cursor-pointer">
              <div className="flex items-center justify-between">
                <h3 className="text-lg  group-hover:text-white transition-colors duration-300">
                  99%
                </h3>

                <div
                  className="flex items-center justify-center rounded-full w-11 h-11 bg-white group-hover:bg-white/80 transition-colors duration-300"
                  style={{ backgroundColor: "#F6F5FB" }}
                >
                  <img
                    src={SatisfyTreetment}
                    alt="doctors"
                    className="w-5 h-5 object-contain"
                  />
                </div>
              </div>

              <p className="mt-1 text-gray-500 group-hover:text-white transition-colors duration-300">
                Satisfying treatment
              </p>
            </div>
          </div>
        </div>

        <div className="Background w-full py-8">
          {isLoading ? (
            <Spinner />
          ) : (
            <DoctorList
              doctors={doctors}
              onBook={BookAppointment}
              selectedDoctorId={selectedDoctorId}
              specialitiesList={specialitiesList}
            />
          )}
        </div>

        <div className="py-14 justify-center items-center">
          <div className="py-8">
            {/* <h1 className="text-xl text-center mb-4">
              <span className="font-semibold text-primary">Quick</span> Access
              Options
            </h1> */}
            <h1 className="text-xl text-center gap-x-2.5 flex flex-wrap justify-center mb-4 w-full">
              <div className="font-semibold text-primary">Quick</div>
              <div>Access Options</div>
            </h1>
            {/* <div className="flex gap-6 bg-gray-200 p-6 justify-center rounded-xl w-fit"> */}
            <div className="flex gap-6 bg-gray-200 p-6 justify-center flex-wrap rounded-xl w-fit">
              {tabs.map((tab) => (
                <div
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`px-10 py-7 rounded-xl border cursor-pointer text-lg font-medium transition-all ${activeTab === tab.id ? "text-white" : ""}
           `}
                  style={{
                    background:
                      activeTab === tab.id
                        ? "linear-gradient(to bottom, #8F6BCB 0%, #E6A9CF 100%)"
                        : "#ffffff",
                    border: "1px solid #9A72C9",
                    transition: "all 0.35s ease",
                  }}
                >
                  {tab.label}
                </div>
              ))}
            </div>
          </div>
          <div className="Background text-center py-12 items-center mx-12 rounded-2xl">
            <h1 className="text-xl leading-tight">
              The future of{" "}
              <span className="font-semibold text-primary">healthcare</span>{" "}
              <br />
              is one click away
            </h1>

            <button
              className="relative flex items-center justify-center px-8 pr-6 pl-14 h-14 border border-primary rounded-full mx-auto mt-6"
              onClick={() => navigate("/doctors")}
            >
              <div className="absolute left-1 flex items-center justify-center w-12 h-12 bg-primary rounded-full">
                <GoArrowUpRight className="w-5 h-5 text-white" />
              </div>

              <span className="text-md font-medium">Get started</span>
            </button>
          </div>
        </div>

        <div className="py-8 justify-center items-center mx-auto ">
          <h1 className="text-xl text-center mb-4">
            Why patient choose{" "}
            <span className="font-semibold text-primary">Telesecure</span>
          </h1>
          <div className="flex flex-wrap py-8 gap-2 items-center justify-center">
            <div>
              <BounceDiv
                icon={SofaIcon}
                text="No waiting rooms"
                gradient={true}
              />

              <BounceDiv icon={SheildIcon} text="Private & Secure" />
            </div>
            <div>
              <BounceDiv icon={DoctorIcon} text="Doctors near you & Online" />
              <BounceDiv icon={MoneyIcon} text="Simple Payments" />
            </div>
          </div>
        </div>

        <div className="Background w-full">
          <section className="relative py-36 overflow-hidden">
            {/* Background Title */}
            <h1
              className="absolute top-8 left-1/2 transform -translate-x-1/2 "
              style={{
                position: "absolute",
                top: 0,
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "190px",
                background: `
linear-gradient(
  to bottom,
  rgba(143,107,203,0.9) 0%,
  rgba(143,107,203,0.6) 30%,
  rgba(230,169,207,0.4) 60%,
  rgba(230,169,207,0.1) 100%
)
`,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                opacity: 0.25,
                fontWeight: "bold",
                // filter: "blur(8px)",
              }}
            >
              TESTIMONIALS
            </h1>
            <h1
              className="absolute top-10 left-1/2 transform -translate-x-1/2 "
              style={{
                background:
                  "linear-gradient(to bottom, #8F6BCB 0%, #E6A9CF 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontSize: "190px",
                fontWeight: "bold",
                textShadow: `
0 20px 60px rgba(143,107,203,0.35),
0 10px 30px rgba(230,169,207,0.25)
`,
              }}
            >
              TESTIMONIALS
            </h1>
            <h1
              className="absolute  left-1/2 transform -translate-x-1/2"
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "190px",
                background: "linear-gradient(to bottom, #FFFFFF14, #8F6BCB)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                opacity: 0.25,
                fontWeight: "bold",
              }}
            >
              TESTIMONIALS
            </h1>
            <div className="">
              <Testimonials />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default NewHome2;
